<template>
  <g-page-wrapper>
    <template slot="pageTitle">

      <div v-if="'PA' === userInfo.auth">
        <g-page-title :title="$t('pages_user_CustomerList.path')"></g-page-title>
      </div>
      <div v-else >
        <g-page-title :title="$t('pages_user_CustomerList.customer.path')"></g-page-title>
      </div>



    </template>
    <g-contents>
      <div class="-p-5">
        <div class="-wrapper-between -mb-3" v-if="isCreateButton">
          <div class="-wrapper-stretch">
            <template >
              <g-button variant="primary" id="customer-list-add" @click="onClickAddCount">
                <g-icon name="add"></g-icon>
                <span>{{$t('pages_user_CustomerList.add_account')}}</span>
              </g-button>
            </template>
          </div>
        </div>

        <div class="-tile-container -bg-white">
          <div class="-wrapper-tile h-v-center-">
            <div class="-tile-container -wrapper-stretch">
              <div class="-wrapper-stretch v-center- -pl-1" style="width: 380px;" v-if="isAdmin">
                <g-dropdown
                  id="customer-list-auth"
                  dropdown-type="button"
                  variant="secondary"
                  class="-width-50"
                  style="width:160px"
                  v-model="groupKey">
                  <g-dropdown-item-wrap>
                    <g-dropdown-item
                      v-for="group in authGroupList"
                      :key="group.key"
                      :text="group.name"
                      :value="group.key"
                    />
                  </g-dropdown-item-wrap>
                </g-dropdown>
                <div class="-bg-white -wrapper-raius -ml-1" style="height:32px; width: 200px;padding-left:20px">
                  <g-dropdown
                    :openItem.sync="showDropdown"
                    id="dashboard-top-select-sales"
                    variant="secondary"
                    class="-width-50"
                    dropdownType="button"
                    @change="onChangeCustomer"
                    v-model="userKey"
                    style="text-overflow: ellipsis">
                    <g-dropdown-item-wrap>
                      <input type="text" class="-input" @keyup="onSearchUserText"
                             style="
                              width: 100%;
                              position: sticky;
                              border: 1px;
                              border-style: solid;
                              height: 32px;
                              display: -ms-inline-flexbox;
                              display: inline-flex;
                              -ms-flex-align: center;
                              align-items: center;
                              border-radius: 4px!important;
                              padding: 0 12px;
                              transition: border-color .3s linear;
                              max-width: 800px;
                              border-color: #d3d8e0!important;
                              z-index: 10000000;
                              top: 0;
                              background: #fff;">
                      <g-dropdown-item :key="item.customerDeptCode" :text="item.customerDeptName" v-show="searchUserText === '' || item.customerDeptName.indexOf(searchUserText) > -1" :value="item" v-for="item in filterCustomerList" />
                    </g-dropdown-item-wrap>
                  </g-dropdown>
                </div>
              </div>
              <div class="-wrapper-stretch h-v-center-" style="width: calc(100% - 380px);">
                <g-search-bar
                  id="customer-list-grid-searchbar"
                  no-border
                  full
                  :placeholder="$t('common.manager_name') + ',' + $t('pages_user_CustomerList.header.userEmail')
                  + ',' + $t('pages_user_CustomerList.header.userTelNo')"
                  style="width: calc(100% - 30px);"
                  v-model="searchText" />
                <g-button
                  id="customer-list-grid-excel-download"
                  variant="borderless"
                  size="small"
                  icon-only
                  class="-mr-0 -minus-ml-2"
                  @click="onClickDownload">
                  <g-icon name="get_app"  width="16px" height="16px" color="gray-1" />
                </g-button>
              </div>
            </div>
          </div>
          <ag-grid-vue
            id="customer-list-grid"
            class="ag-theme-balham"
            style="height: 500px;"
            row-height="30"
            header-height="30"
            ref="agGrid"
            :modules="modules"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :gridOptions="gridOptions"
            :rowData="userList.users"
            :overlayLoadingTemplate="overlayLoadingTemplate"
            :loadingOverlayComponent="loadingOverlayComponent"
            :loadingOverlayComponentParams="loadingOverlayComponentParams"
            :overlayNoRowsTemplate="overlayNoRowsTemplate"
            :noRowsOverlayComponent="noRowsOverlayComponent"
            :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
            :frameworkComponents="frameworkComponents"
            :paginationPageSize="payLoad.size"
            :pagination="true"
            :suppressPaginationPanel="true"
            :suppressScrollOnNewData="true"
            @grid-ready="onGridReady"
            @row-clicked="rowClicked"
            @row-data-changed="onRowDataChanged"
            @pagination-changed="paginationChanged">
          </ag-grid-vue>
          <g-pagenation
            id="customer-list-grid-paging"
            class="-py-6 -pr-2"
            :page-no="payLoad.pageNo == 0 ? 1 : payLoad.pageNo"
            :page-size-list="pageSizeList"
            :page-size="payLoad.size"
            :total-count="!!userList && userList.totalCount ? userList.totalCount : 0"
            @change-page-no="onChangePageNo"
            @change-page-size="onChangePageSize"/>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
/*
BMM : jihee.kim@bespinglobal.com
AM : ripple31@nate.com
BS : may.kim@bespinglobal.com
BM : boyoung.lee@bespinglobal.com
*/

import { mapActions, mapGetters } from 'vuex'
import { AgGridVue } from 'ag-grid-vue';
import { DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE, LOCALE, AUTH_GROUP } from "@/constants/constants";
import AgGridMixin from '../../mixin/AgGrid.mixin'
import TagCell from '../../components/ag-grid/TagCell'
import CodeList from '@/code/CodeList'
import {cloneDeep} from 'loadsh'

export default {
  name: 'user-list-for-admin',
  componentName: 'UserListForAdmin',
  components: {
    AgGridVue
  },
  mixins: [AgGridMixin()],
  data () {
    return {
      pageSizeList: DEFAULT_OPTION_PER_PAGE,
      payLoad: {},
      columnDefs: [],
      searchText: '',
      groupKey: '',
      userKey: '',
      searchUserText: '',
      allGroupList: [],
      customerSearchText: '',
      selectCustomer: {},
      cloneCustomerList: [],
      showDropdown: false,
      multiSelectWidth: 320,
      customerSelectTop:  {}

    }
  },
  computed: {
    ...mapGetters('customer', [
      'groupList'
    ]),
    ...mapGetters('dashboard', ['customerList']),
    ...mapGetters('user', ['userInfo', 'userList',  'codeUserList']),
    dropIcon () {
      return this.showDropdown ? 'expand_less' : 'expand_more'
    },
    isCreateButton () {
      if (this.userInfo.auth === AUTH_GROUP.BespinAdmin) {
        return true
      }
      return false
    },
    authGroupList () {
      return this.allGroupList
    },
    isProductManager () {
      return this.userInfo.auth === AUTH_GROUP.BespinProductManager
    },
    isSales () {
      return this.userInfo.auth === AUTH_GROUP.BespinSales
    },
    isAdmin () {
      return this.userInfo.auth === AUTH_GROUP.BespinAdmin
    },
    filterCustomerList () {
      if (this.customerSearchText.trim() === '') {
        return this.cloneCustomerList
      }
      return this.cloneCustomerList.filter(item => item.customerDeptName.toUpperCase().indexOf(this.customerSearchText.toUpperCase().trim()) !== -1)
    },
  },
  methods: {
    ...mapActions('customer', ['getCustomerList']),
    ...mapActions('user', ['getUserList', 'getCSVDownLoad']),
    ...mapActions('dashboard', ['getCustomers']),

    onSearchUserText(e) {
      this.searchUserText = e.target.value
    },

    onKeyupSearchText (e) {
      this.customerSearchText = e.target.value
    },
    onClickMultiSelect (e) {
      if(!this.isGroupCustomerOrAll()){
        return
      }
      if (this.showDropdown) {
        this.multiSelectWidth = 320
        setTimeout(() => {
          this.customerSearchText = ''
        }, 100)
      } else {
        this.multiSelectWidth = this.$refs.refDropdown.$el.getBoundingClientRect().width
      }
      this.showDropdown = !this.showDropdown
    },
    onChangeCustomer (e) {
      // this.onClickMultiSelect()
      this.selectCustomer = e;

      this.payLoad.pageNo = 1;
      this.payLoad.customerCode = e.customerCode == "ALL" ? "": e.customerCode;
      this.payLoad.customerDeptCode = e.deptCode ==  "ALL" ? "": e.deptCode;
      this.changeUserList()
    },
    setColumn () {
      if(this.userInfo.auth === AUTH_GROUP.BespinAdmin ){
        this.columnDefs = [
          {
            field: 'customerName',
            headerName: this.$t('pages_user_CustomerList.header.customerName'),
            unSortIcon: true,
            filter: true,
            sortable: false,
            cellStyle : {"cursor":"pointer"}
          }, {
            field: 'customerDeptName',
            headerName: this.$t('pages_user_CustomerList.header.customerDeptName'),
            sortable: false,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}

          }, {
            field: 'userName',
            headerName: this.$t('common.manager_name'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          }, {
            field: 'userEmail',
            headerName: this.$t('pages_user_CustomerList.header.userEmail'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          }, {
            field: 'userTelNo',
            headerName: this.$t('pages_user_CustomerList.header.userTelNo'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          }, {
            field: 'lastAccessTime',
            headerName: this.$t('pages_user_CustomerList.header.lastAccessTime'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            field: 'auth',
            headerName: this.$t('common.auth'),
            cellRenderer: (params) => {
              const group = this.groupList.find(item => item.id === params.value) || {}
              if (this.locale === LOCALE.KOREAN) {
                return group.nameKo
              }
              return group.nameEn
            },
            unSortIcon: false,
            sortable: false,
            cellStyle : {"cursor":"pointer"}
          },
          {
            field: 'useYn',
            headerName: this.$t('pages_user_CustomerList.header.status'),
            sortable: true,
            unSortIcon: true,
            cellRendererFramework: TagCell((params) => {
              let text = ''
              let color = ''
              if (params.value === 'Y') {
                text = this.$t('pages_user_CustomerList.row.active')
                color = 'green-'
              } else if (params.value === 'N') {
                text = this.$t('pages_user_CustomerList.row.deactive')
                color = 'gray-'
              } else if (params.value === 'D') {
                text = this.$t('pages_user_CustomerList.row.withdraw')
                color = 'red-'
              }
              return {
                text, color
              }
            }),
            cellStyle : {"cursor":"pointer"},
          },
          {
            field: 'idpStatus',
            headerName: this.$t('pages_user_CustomerList.header.idp.status'),
            sortable: false,
            unSortIcon: true,
            cellRendererFramework: TagCell((params) => {
              let text = ''
              let color = ''
              if (params.value === 'ACTIVE') {
                text = this.$t('pages_user_CustomerList.row.active')
                color = 'green-'
              } else if (params.value === 'DEACTIVE') {
                text = this.$t('pages_user_CustomerList.row.deactive')
                color = 'gray-'
              } else if (params.value === 'DELETE') {
                text = this.$t('pages_user_CustomerList.row.withdraw')
                color = 'red-'
              }
              return {
                text, color
              }
            }),
            cellStyle : {"cursor":"pointer"},
          },
        ]
      }else{

        this.columnDefs = [
          {
            field: 'customerName',
            headerName: this.$t('pages_user_CustomerList.header.customerName'),
            unSortIcon: true,
            filter: true,
          }, {
            field: 'customerDeptName',
            headerName: this.$t('pages_user_CustomerList.header.customerDeptName'),
            sortable: true,
            unSortIcon: true,
          }, {
            field: 'userName',
            headerName: this.$t('common.manager_name'),
            sortable: true,
            unSortIcon: true,
          }, {
            field: 'userEmail',
            headerName: this.$t('pages_user_CustomerList.header.userEmail'),
            sortable: true,
            unSortIcon: true,
          }, {
            field: 'userTelNo',
            headerName: this.$t('pages_user_CustomerList.header.userTelNo'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            field: 'duty',
            headerName: this.$t('pages_user_CustomerList.row.duty'),
            sortable: true,
            unSortIcon: true,
            width: 70,
          },{
            field: 'isPortalYn',
            headerName: this.$t('pages_user_CustomerList.row.isPortalYn'),
            sortable: true,
            unSortIcon: true,
          },
        ]
      }
    },
    onGridReady(params) {
      let thatPayLoad = this.payLoad;
      this.setGridParams(params)
      this.columnDefs.forEach(item => {
        const column = this.gridOptions.columnApi.getColumn(item.field)
        column.addEventListener('sortChanged', (value) => {
          const sortVal = column.getSort()
          this.payLoad.orderCol = item.field
          if (sortVal === 'desc') {
            this.payLoad.desc = true
          } else if (sortVal === 'asc') {
            this.payLoad.desc = false
          } else {
            this.payLoad.orderCol = null
            this.payLoad.desc = null
          }
          this.changeUserList();
        })
      })
      //this.changeUserList()
      this.fitGrid()
    },
    onRowDataChanged (e) {
      if (this.codeUserList === CodeList.READY) {
        this.noRowsOverlayComponentParams.exception = false
        if(!!this.gridApi){
          this.gridApi.showLoadingOverlay()
        }
      } else if (this.codeUserList === CodeList.EXCEPTION) {
        this.noRowsOverlayComponentParams.exception = true
        this.gridApi.showNoRowsOverlay()
      } else if (this.codeUserList === CodeList.SUCCESS) {
        if (!!this.userList  && this.userList.users.length > 0) {
          this.gridApi.hideOverlay()
        } else {
          this.gridApi.showNoRowsOverlay()
        }
      }

      this.fitGrid()
    },
    rowClicked (e) {

      if (this.isAdmin) {
        this.$router.push(`/user/info?userid=${e.data.userId}`)
      }
    },
    paginationChanged (e) {
      //this.paging.totalCount = e.api.rowModel.rowsToDisplay.length
    },
    onClickAddCount () {
      this.$router.push('/user/create')
    },
    onClickAddCustomerPortalCount () {
      this.$router.push('/user/customer_portal_create')
    },
    onChangePageNo (pageNo) {
      this.payLoad.pageNo = pageNo;
      //this.gridApi.paginationGoToPage(pageNo - 1);
      this.changeUserList()
    },
    onChangePageSize (pageSize) {
      this.payLoad.size = pageSize;
      this.payLoad.pageNo = 1;
      this.changeUserList()
    },
    onSearch() {
      this.payLoad.pageNo = 1;
      this.changeUserList()
    },
    onClickDownload () {


      let url = `${location.origin}/api/v1/users/csv?auth=${!!this.payLoad.auth ? this.payLoad.auth: '' }&customerCode=${this.payLoad.customerCode}&customerDeptCode=${!!this.payLoad.customerDeptCode? this.payLoad.customerDeptCode: ''}&searchText=${this.payLoad.searchText}&orderCol=${!!this.payLoad.orderCol? this.payLoad.orderCol: ''}&desc=${!!this.payLoad.desc ? this.payLoad.desc: ''}&pageNo=1&size=${this.userList.totalCount ? this.userList.totalCount : 0}`
      let param = {
        url: url,
        fileName : "accounts.csv"
      }
      this.getCSVDownLoad(param);
    },
    changeUserList(){
      //let payLoad = {};
      if(!!this.gridApi){
        this.gridApi.showLoadingOverlay()
      }
      this.getUserList(this.payLoad)

    },
    isGroupCustomerOrAll(){
      let selectedGroup = this.groupList.find(group => group.key == this.groupKey);
      if (!selectedGroup){
        return true;
      }
      return selectedGroup['id'] == AUTH_GROUP.AccountManager || selectedGroup['id'] == ''
    }
  },
  watch: {
    searchText () {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.payLoad.pageNo = 1
        this.payLoad.searchText =  this.searchText;
        this.gridOptions.columnApi.resetColumnState();
        this.onSearch()
      }, 200);
    },
    groupKey () {
      this.payLoad.auth = this.groupKey;
      this.payLoad.pageNo = 1;
      if(!this.isGroupCustomerOrAll()){
        this.selectCustomer = this.cloneCustomerList.find(customer =>  customer.customerDeptCode == 'X10000' )
        this.payLoad.customerCode = this.selectCustomer.customerCode
        this.payLoad.customerDeptCode = this.selectCustomer.deptCode
      }else{
        this.selectCustomer = this.cloneCustomerList[0]
        this.payLoad.customerCode = this.selectCustomer.customerCode == "ALL" ? "": this.selectCustomer.customerCode
        this.payLoad.customerDeptCode = this.selectCustomer.deptCode ==  "ALL" ? "": this.selectCustomer.deptCode
      }


      this.changeUserList();
      this.gridApi.showLoadingOverlay()
    },
    customerList(){
      this.cloneCustomerList = cloneDeep(this.customerList)
      this.selectCustomer = this.cloneCustomerList[0];
      this.selectCustomer.customerDeptName = this.$t("pages_user_CustomerList.customer.total")
    }
  },
  mounted (){
    this.getCustomers("null");
  },
  beforeMount () {
    this.payLoad = {
      companyCode : this.userInfo.companyCode,
      pageNo : 1,
      size : DEFAULT_PAGE_SIZE,
      searchText : this.searchText,
      orderCol : this.orderCol,
      desc : this.desc,
      customerCode : '',
      customerDeptCode : ''
    }

    if(this.userInfo.auth === AUTH_GROUP.AccountManager){
      this.$showToast(this.$t('pages_contract_ContractDetail.no.auth'))
      this.$popupManager.close(this.instKey)
      this.$router.push("/")
    }
    this.defaultColDef.sortable = true
    this.defaultColDef.filter = false
    this.allGroupList = this.groupList.concat();
    this.allGroupList.unshift({
      key:  "",
      id: "",
      name: this.$t("pages_user_CustomerList.total")
    });

    if (this.allGroupList.length === 1) {
      this.groupKey = this.allGroupList[0].key
    }
    //this.changeUserList();
  }
}

</script>




// WEBPACK FOOTER //
// src/pages/user/components/UserListForAdmin.vue